import service from "@/api/request";
export const getCourseUrl = () => service.getByQuery("/courseAdmin/config/getCourseUrl");
/**
 * FIXME:
 * 1. 该API传参方式错误，需要沟通后端进行修改为通过data传参（此处为query）
 */
export const saveCourseUrl = (type, path) => service.postByForm(`/courseAdmin/config/saveCourseUrl?type=${type}&url=${path}`, "" // 因POST方法需传入data，且此处API存在传参方式的问题，此处占位
);
export const getCourseRecommend = () => service.getByQuery('/courseAdmin/recommendCourseProduct/list');
export const saveCourseRecommend = (data) => service.postByJson('/courseAdmin/recommendCourseProduct/update', data);
